
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/code-org-courses-for-kids",
      function () {
        return require("private-next-pages/courses/code-org-courses-for-kids.tsx");
      }
    ]);
  